import Flashmeeting_icon from '@/components/apps_icon/flashmeeting_icon.vue';
import Kamishibai_icon from '@/components/apps_icon/kamishibai_icon.vue';
import Planiteam_icon from '@/components/apps_icon/planiteam_icon.vue';
import Resolution_icon from '@/components/apps_icon/resolution_icon.vue';
import Umanforge_icon from '@/components/apps_icon/umanforge_icon.vue';

export const appUmanforge = Object.freeze( { appKey: 'Umanforge', icon: Umanforge_icon, url: process.env.VUE_APP_UMANFORGE_BASE_URL } );
export const appFlashmeeting = Object.freeze( { appKey: 'Flashmeeting', icon: Flashmeeting_icon, url: process.env.VUE_APP_FLASHMEETING_BASE_URL } );
export const appKamishibai = Object.freeze( { appKey: 'Kamishibai', icon: Kamishibai_icon, url: process.env.VUE_APP_KAMISHIBAI_BASE_URL } );
export const appResolution = Object.freeze( { appKey: 'Resolution', icon: Resolution_icon, url: location.host } );
export const appPlaniteam = Object.freeze( { appKey: 'Planiteam', icon: Planiteam_icon, url: process.env.VUE_APP_PLANITEAM_BASE_URL } );

export const apps = Object.freeze( [
  appUmanforge,
  appFlashmeeting,
  appKamishibai,
  appResolution,
  appPlaniteam
] );